export default "__VITE_ASSET__DrT7ovo1__"